import { Injectable } from "@angular/core";
import { BehaviorSubject, Observer, Subject } from "rxjs";
import { ApiService } from "../services/api.service";
import { ApiServiceDelegate } from "../models/api-service-delegate";
import { NzMessageService } from "ng-zorro-antd/message";
import { ApiCollection } from "../providers/api-collection";
import { VendorsComponent } from "../pages/vendors/vendors.component";
import { CityResponseModel, CountryResponseModel, StateResponseModel, UserResponseModel, VendorResponseModel,taxTypeResponseModal,vendorTypeRespModal } from "../models/vendor.model";
import { VendorDrawerComponent } from "../components/vendor-drawer/vendor-drawer.component";
import { CountryCodeResponseModel } from "../models/client.model";
import { VendorPocDetailsComponent } from "../components/vendor-poc-details/vendor-poc-details.component";
import { CetVendorDetailsComponent } from "../components/console-event-tab/cet-vendor-details/cet-vendor-details.component";
import { VendorAddPocComponent } from "../components/vendor-add-poc/vendor-add-poc.component";


@Injectable({
    providedIn: "root",
})

export class VendorViewModel {
    cetVendorDetailsComponent:CetVendorDetailsComponent
    vendorPocDetailsComponent:VendorPocDetailsComponent
    parentVendorsComponent: VendorsComponent;
    vendorAddPocComponent:VendorAddPocComponent
    vendorDrawerComponent:VendorDrawerComponent
    userList = new BehaviorSubject<UserResponseModel>(new UserResponseModel());
    vendorResponseModel = new BehaviorSubject<VendorResponseModel>(new VendorResponseModel());
    countryList = new BehaviorSubject<CountryResponseModel>(new CountryResponseModel());
    stateList = new BehaviorSubject<StateResponseModel>(new StateResponseModel());
    cityList = new BehaviorSubject<CityResponseModel>(new CityResponseModel());
    countryCodeList = new BehaviorSubject<CountryCodeResponseModel>(new CountryCodeResponseModel())
    taxTypeResponseModal = new BehaviorSubject<taxTypeResponseModal>(new taxTypeResponseModal());
    vendorTypeRespModal = new BehaviorSubject<vendorTypeRespModal>(new vendorTypeRespModal());

    constructor(
        private apiService: ApiService,
        private message: NzMessageService
    ) {}


    subscribeToVendors(observer: Observer<VendorResponseModel>) {
        this.vendorResponseModel.subscribe(observer);
    }

     subscribeToTaxTypes(observer: Observer<taxTypeResponseModal>) {
        this.taxTypeResponseModal.subscribe(observer);
    }

     subscribeToVendorTypes(observer: Observer<vendorTypeRespModal>) {
        this.vendorTypeRespModal.subscribe(observer);
    }

    /**
   * Helper function to format backend validation errors for display.
   * @param errors The error object from the backend.
   * @returns A string containing formatted error messages.
   */
  private formatBackendErrors(errors: any): void {
    let errorMessages = '';
    if (typeof errors === 'object') {
      for (const key in errors) {
        if (errors.hasOwnProperty(key)) {
          errorMessages += `<strong>${key}:</strong> ${Array.isArray(errors[key]) ? errors[key].join(', ') : errors[key]}<br>`;
        }
      }
    } else {
      errorMessages = errors.toString();
    }
    this.message.error(errorMessages, { nzDuration: 1000 });
    // return errorMessages;
  }

    getUserList(page: number, page_size: number) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.User + '?page=' + page + '&page_size=' + page_size + '&is_deleted=false',
            Success: (e: any) => {
                this.userList.next(e)
                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getCountryList(page: number, page_size: number) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.Country + '?page=' + page + '&page_size=' + page_size,
            Success: (e: any) => {
                this.countryList.next(e)
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getStateListById(page: number, page_size: number, id?: number,name?:string) {
        let url = ApiCollection.State + '?page=' + page + '&page_size=' + page_size
        if (id) {
            url += '&country=' + id
        }
        if(name){
            url += '&name=' + name
        }
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: url,
            Success: (e: any) => {
                this.stateList.next(e)
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getCityListById(page: number, page_size: number, id?: number,name?:string) {
        let url = ApiCollection.City + '?page=' + page + '&page_size=' + page_size
        if(id){
            url += '&state=' + id
        }
        if(name){
            url += '&name=' + name
        }
        console.log(url)
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action:url,
            Success: (e: any) => {
                this.cityList.next(e)
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }


    createPOC(data: any) {
        let d: ApiServiceDelegate = {
            Data: data,
            Method: "POST",
            Action: ApiCollection.Vendor_POC,
            Success: (e: any) => {
                this.vendorAddPocComponent.pocCreated()
                this.message.success("Vendor POC created successfully", { nzDuration: 1000 });
                return e;
            },
            Error: (e: any) => {
                this.message.error(String(e), {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }
    // updatePOC(data: any, id: number,caller:string) {
    //     let d: ApiServiceDelegate = {
    //         Data: data,
    //         Method: "PATCH",
    //         Action: ApiCollection.Vendor_POC + '/' + id,
    //         Success: (e: any) => {
    //             if(caller == 'vendorAddPocComponent'){
    //                  this.vendorAddPocComponent.pocUpdated()
    //             }

    //             this.message.success("vendor POC updated successfully", { nzDuration: 1000 });
    //             return e;
    //         },
    //         Error: (e: any) => {
    //             this.message.error(String(e), {nzDuration: 1000});
    //             console.log(e)
    //             return e;
    //         },
    //     };
    //     this.apiService.callService(d);
    // }

    updatePOC(data: any, id: number, caller: string, callback?: Function) {
        let d: ApiServiceDelegate = {
            Data: data,
            Method: "PATCH",
            Action: ApiCollection.Vendor_POC + '/' + id,
            Success: (e: any) => {
                if(caller == 'vendorAddPocComponent'){
                    this.vendorAddPocComponent.pocUpdated();
                }

                this.message.success("vendor POC updated successfully", { nzDuration: 1000 });

                // Call the callback if provided (backward-compatible)
                if (callback) {
                    callback(e);
                }

                return e;
            },
            Error: (e: any) => {
                this.message.error(String(e), { nzDuration: 1000 });
                console.log(e);
                return e;
            },
        };
        this.apiService.callService(d);
    }


    deletePOC(id: number) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "DELETE",
            Action: ApiCollection.Vendor_POC + '/' + id,
            Success: (e: any) => {
                this.cetVendorDetailsComponent.pocDeleted();
                this.message.success("Vendor POC deleted successfully", { nzDuration: 1000 });
                return e;
            },
            Error: (e: String) => {
                this.message.error(String(e), {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

     getCountryCodeList() {
        let src = ApiCollection.Country_Code + '?page=1&page_size=1000' ;

        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: src,
            Success: (e: any) => {
                this.countryCodeList.next(e)
                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }


    getVendors(
        page: number,
        page_size: number,
        search: string,
        filters?: { categories_serviced?: number[]; location?: string }
    ) {
        let url = ApiCollection.Vendor + '?page=' + page + '&page_size=' + page_size;
        if (search) {
            url += '&search=' + encodeURIComponent(search);
        }
        if (filters?.categories_serviced && filters.categories_serviced.length > 0) {
            // Multi-select filter shares the existing single-value query key; selected ids
            // are joined with a comma into one value rather than repeating the key.
            url += '&categories_serviced=' + encodeURIComponent(filters.categories_serviced.join(','));
        }
        if (filters?.location) {
            url += '&city_details=' + encodeURIComponent(filters.location);
        }
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: url,
            Success: (e: any) => {
                this.vendorResponseModel.next(e);
                this.parentVendorsComponent.vendorsReceived();
                return e;
            },
            Error: (e: any) => {
                // this.message.error(e, { nzDuration: 1000 })
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    // createVendor( data:any) {
    //     let str= ApiCollection.Vendor
    //     let d: ApiServiceDelegate = {
    //         Data: data,
    //         Method: "POST",
    //         Action: str,
    //         Success: (e: any) => {
    //             this.vendorDrawerComponent.handleModelClose()
    //             return e;
    //         },
    //         Error: (e: String) => {
    //             this.formatBackendErrors(e)
    //             return e;
    //         },
    //     };
    //     this.apiService.callService(d);
    // }

    createVendor(data: any, onSuccess?: (res: any) => void, onError?: (err: any) => void) {
      let str = ApiCollection.Vendor;
      let d: ApiServiceDelegate = {
        Data: data,
        Method: "POST",
        Action: str,
        Success: (e: any) => {
          this.vendorDrawerComponent.handleModelClose();
          if (onSuccess) onSuccess(e);
          return e;
        },
        Error: (e: string) => {
          this.formatBackendErrors(e);
          if (onError) onError(e);
          return e;
        },
      };
      this.apiService.callService(d);
    }




    // updateVendor( data:any) {
    //     let str= ApiCollection.Vendor + '/' + data.id
    //     let d: ApiServiceDelegate = {
    //         Data: data,
    //         Method: "PATCH",
    //         Action: str,
    //         Success: (e: any) => {
    //             this.vendorDrawerComponent.handleModelClose()
    //             return e;
    //         },
    //         Error: (e: String) => {
    //             this.formatBackendErrors(e)
    //             return e;
    //         },
    //     };
    //     this.apiService.callService(d);
    // }

        updateVendor(data: any, onSuccess?: (res: any) => void, onError?: (err: any) => void) {
          let str = ApiCollection.Vendor + '/' + data.id;
          let d: ApiServiceDelegate = {
            Data: data,
            Method: "PATCH",
            Action: str,
            Success: (e: any) => {
              this.vendorDrawerComponent.handleModelClose();
              if (onSuccess) onSuccess(e);   // ✅ trigger callback
              return e;
            },
            Error: (e: string) => {
              this.formatBackendErrors(e);
              if (onError) onError(e);       // ✅ trigger callback
              return e;
            },
          };
          this.apiService.callService(d);
        }


      deleteVendor( data:any) {
          let str= ApiCollection.Vendor + '/' + data.id
          let d: ApiServiceDelegate = {
              Data: {},
              Method: "DELETE",
              Action: str,
              Success: (e: any) => {
                  this.message.success('Vendor deleted successfully', { nzDuration: 1000 })
                  this.cetVendorDetailsComponent.vendorDeletd()
                  return e;
              },
              Error: (e: String) => {
                  this.formatBackendErrors(e)
                  return e;
              },
          };
          this.apiService.callService(d);
      }

      getvendorTax(page:number,page_size:number){
        let url = ApiCollection.tax_type +'?page=' + page + '&page_size=' + page_size;


        let d: ApiServiceDelegate = {
              Data: {},
              Method: "GET",
              Action: url,
              Success: (e: any) => {
                  this.taxTypeResponseModal.next(e);
                  return e;
              },
              Error: (e: any) => {
                  // this.message.error(e, { nzDuration: 1000 })
                  this.formatBackendErrors(e)
                  return e;
              },
          };
          this.apiService.callService(d);
      }

     getvendorType(page:number,page_size:number){
      let url = ApiCollection.vendor_type +'?page=' + page + '&page_size=' + page_size;


       let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: url,
            Success: (e: any) => {
                this.vendorTypeRespModal.next(e);
                return e;
            },
            Error: (e: any) => {
                // this.message.error(e, { nzDuration: 1000 })
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    createVendorTax(data: any) {
      let str = ApiCollection.vendor_tax;
      let d: ApiServiceDelegate = {
        Data: data,
        Method: "POST",
        Action: str,
        Success: (e: any) => {
          // you can close modal or show success message here if needed
          return e;
        },
        Error: (e: string) => {
          this.formatBackendErrors(e);
          return e;
        },
      };
      this.apiService.callService(d);
    }

    fetchVendorTax(id: any, onSuccess?: (taxData: any) => void) {
      let url = ApiCollection.vendor_tax + '?vendor=' + id;

      let d: ApiServiceDelegate = {
        Data: {},
        Method: "GET",
        Action: url,
        Success: (res: any) => {
          const taxData = res?.results?.[0] || null;
          if (onSuccess && taxData) {
            onSuccess(taxData);
          }
          return res;
        },
        Error: (e: String) => {
          this.formatBackendErrors(e);
          return e;
        },
      };

      this.apiService.callService(d);
    }

  updateVendorTax(id: any,payload:any) {
        let str = ApiCollection.vendor_tax+ '/'+ id;;
        let d: ApiServiceDelegate = {
          Data: payload,
          Method: "PATCH",
          Action: str,
          Success: (e: any) => {
            return e;
          },
          Error: (e: string) => {
            this.formatBackendErrors(e);
            return e;
          },
        };
        this.apiService.callService(d);
  }

}
